import React from 'react';
import PropTypes from 'prop-types';
import {Form, Formik} from 'formik';
import {withRouter} from 'react-router-dom';
import {get} from 'lodash';
import Modal from 'shared/components/modal';
import Label from 'shared/components/label';
import TextInput from 'src/components/inputs/text-input';
import Button from 'src/components/button';
import AreYouSure from 'src/components/AreYouSure/index';
import 'stylesheets/components/student-profile/spot-award-modal.scss';

class SpotAwardModal extends React.Component {
  static propTypes = {
    location: PropTypes.shape({
      pathname: PropTypes.string.isRequired,
    }).isRequired,
    history: PropTypes.shape({
      push: PropTypes.func.isRequired,
    }).isRequired,
    loading: PropTypes.shape({
      studentProfileInitialInfo: PropTypes.bool,
    }).isRequired,
    student: PropTypes.shape({
      _id: PropTypes.string.isRequired,
    }).isRequired,
    awardSpotScholarship: PropTypes.func.isRequired,
    collegeDataForStudent: PropTypes.shape({
      divisor: PropTypes.number.isRequired,
      earningRelationship: PropTypes.shape({
        spotAward: PropTypes.shape({
          createdAt: PropTypes.string.isRequired,
          name: PropTypes.string.isRequired,
        }),
      }).isRequired,
    }).isRequired,
  };

  handleClose = () => {
    const {
      location: {pathname},
      history: {push},
    } = this.props;

    push(pathname.split('/spot-award')[0]);
  };

  validate = (values) => {
    const errors = {};

    if (!values.name) {
      errors.name = 'Scholarship name is required.';
    }

    if (!values.amount) {
      errors.amount = 'Scholarship amount is required.';
    }

    if (values.amount < 1) {
      errors.amount = 'Scholarship amount must be a positive number.';
    }

    return errors;
  };

  render() {
    if (this.props.loading.studentProfileInitialInfo) return null;

    const {
      student: {_id},
      awardSpotScholarship,
      collegeDataForStudent: {divisor},
    } = this.props;

    const spotAward = get(this.props.collegeDataForStudent.earningRelationship, 'spotAward', {
      name: '',
      amount: null,
    });

    return (
      <Modal
        className="student-profile-spot-award-modal"
        show
        onClose={this.handleClose}
        forceNotIonic
      >
        <Modal.TextHeader onClose={this.handleClose}>
          {spotAward ? 'Update' : 'Grant'} SPOT Award
        </Modal.TextHeader>
        <Modal.Body>
          <p className="shared-font body">
            The student will receive this award <span className="shared-font bold">or</span>
            &nbsp;their micro-scholarship total, whichever is greater. The student will be
            immediately awarded.
          </p>
          <Formik
            initialValues={{...spotAward, studentId: _id}}
            initialStatus="ok"
            validate={this.validate}
            onSubmit={awardSpotScholarship}
          >
            {({values: {name, amount}, errors, handleChange, handleSubmit}) => (
              <Form>
                <Label>
                  Award name
                  <TextInput
                    required
                    name="name"
                    value={name}
                    onChange={handleChange}
                    error={errors.name}
                    placeholder="Super Scholar Award"
                  />
                </Label>
                <Label>
                  {`${divisor ? `${divisor}-Year` : ''} total amount`}
                  <span className="student-profile-spot-award-modal-currency">
                    <TextInput
                      required
                      name="amount"
                      value={amount}
                      onChange={handleChange}
                      error={errors.amount}
                      placeholder="0"
                      type="number"
                    />
                  </span>
                </Label>
                <div className="student-profile-spot-award-modal-buttons">
                  <Button type="button" outline margin={false} onClick={this.handleClose}>
                    Cancel
                  </Button>
                  <AreYouSure
                    id="create-spot-award-confirmation"
                    onYes={handleSubmit}
                    buttonName="award-spot-scholarship"
                    text="Are you sure you want to grant this award?"
                    buttonText="Confirm"
                    buttonType="submit"
                  >
                    <Button
                      type="button"
                      margin={false}
                      className="student-profile-spot-award-modal-award-button"
                      buttonName="award-spot-scholarship"
                    >
                      Grant Award
                    </Button>
                  </AreYouSure>
                </div>
              </Form>
            )}
          </Formik>
        </Modal.Body>
      </Modal>
    );
  }
}

export default withRouter(SpotAwardModal);
